import { createSlice } from '@reduxjs/toolkit';
import { createDropdownFilterInitialState, createDropdownFilterReducers } from 'common/utils/sliceUtils/filterSliceUtils';

import type { RootState } from '../../app/store';

const initialState = createDropdownFilterInitialState();

const roleClaimMembershipSlice = createSlice({
    name: 'roleClaimMembership',
    initialState,
    reducers: () => ({
        ...createDropdownFilterReducers(initialState),
    })
});

// eslint-disable-next-line no-restricted-syntax
export default roleClaimMembershipSlice.reducer;
export const { addNewFilter, removeFilter, clearFilters, checkClaimTypeFilter } = roleClaimMembershipSlice.actions;
export const selectFilters = (state: RootState) => state.roleClaimMembership.filters;
